import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ExpenseStatsCard } from "../cards/ExpenseStatsCard";

interface ExpenseStatsSectionProps {
  formatCurrency: (amount: number) => string;
  formatPercentage: (value: number) => string;
  stats: {
    totalExpenses: number;
    monthlyChange: number;
    averageDaily: number;
    daysWithExpenses: number;
    expenseCount: number;
    categoryCount: number;
  };
}

export const ExpenseStatsSection = ({ formatCurrency, formatPercentage, stats }: ExpenseStatsSectionProps) => {
  // Vérification que stats existe et initialisation des valeurs par défaut si nécessaire
  const {
    totalExpenses = 0,
    monthlyChange = 0,
    averageDaily = 0,
    daysWithExpenses = 0,
    expenseCount = 0,
    categoryCount = 0
  } = stats || {};

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <ExpenseStatsCard
        title="Total des Dépenses"
        value={formatCurrency(totalExpenses)}
        subtitle={`${monthlyChange > 0 ? '↑' : '↓'} ${formatPercentage(Math.abs(monthlyChange))} vs mois précédent`}
        className="bg-gradient-to-br from-red-500 to-red-600"
      />

      <div className="relative">
        <ExpenseStatsCard
          title="Moyenne Journalière"
          value={formatCurrency(averageDaily)}
          subtitle={`${daysWithExpenses} jours avec dépenses`}
          className="bg-gradient-to-br from-orange-500 to-orange-600"
        />
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger className="absolute top-4 right-4">
              <Info className="h-4 w-4 text-white/80 hover:text-white transition-colors" />
            </TooltipTrigger>
            <TooltipContent>
              <p>Cette moyenne est calculée en divisant le montant total des dépenses ({formatCurrency(totalExpenses)}) par le nombre de jours avec des dépenses ({daysWithExpenses} jours) sur la période.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>

      <ExpenseStatsCard
        title="Nombre de Dépenses"
        value={expenseCount.toString()}
        subtitle="transactions ce mois"
        className="bg-gradient-to-br from-yellow-500 to-yellow-600"
      />

      <ExpenseStatsCard
        title="Catégories"
        value={categoryCount.toString()}
        subtitle="types de dépenses"
        className="bg-gradient-to-br from-green-500 to-green-600"
      />
    </div>
  );
};